import api from './axios';

const formData = (fields, files) => {
  const fd = new FormData();
  Object.entries(fields).forEach(([k, v]) => {
    if (v !== undefined && v !== null) fd.append(k, v);
  });
  if (files) files.forEach((f) => fd.append('images', f));
  return fd;
};

export const fetchMarketplace = (params) =>
  api.get('/products/marketplace', { params }).then((r) => r.data);

export const fetchMarketplaceProduct = (id) =>
  api.get(`/products/marketplace/${id}`).then((r) => r.data);

export const fetchSalonProducts = (params) =>
  api.get('/products', { params }).then((r) => r.data);

export const fetchProductSuggestions = (params) =>
  api.get('/products/suggestions', { params }).then((r) => r.data);

// alias for internal pages that expect fetchProducts
export const fetchProducts = fetchSalonProducts;

export const createProduct = (fields, files, onProgress) =>
  api
    .post('/products', formData(fields, files), {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: onProgress,
    })
    .then((r) => r.data);

export const updateProduct = (id, fields) =>
  api.put(`/products/${id}`, fields).then((r) => r.data);

export const publishProduct = (id, isPublished) =>
  api.put(`/products/${id}/publish`, { isPublished }).then((r) => r.data);

export const deleteProduct = (id) => api.delete(`/products/${id}`).then((r) => r.data);

export const updateProductStock = (id, stock) =>
  api.put(`/products/${id}/stock`, { stock }).then((r) => r.data);
